import format from 'date-fns/format';
import { ru } from 'date-fns/locale'

export const dateAndTime = date => {
	return date ? format(new Date(date), 'dd.MM.yyyy kk:mm', { locale: ru, weekStartsOn: 1 }) : null;
};
